<template>
    <div class="datePicker">
        <label style="color:var(--darkgray)">{{ label }}:</label>
        <date-picker :show-time-panel="!hideTime && showTimePanel" :open.sync="open" :shortcuts="shortcutsObjects"
                     :format="dateFormat" @change="handleChange" value-type="timestamp" range-separator=" até "
                     v-model="date" type="datetime" range :disabled-date="notAfterToday">
            <template v-slot:footer>
                <button v-if="!hideTime" class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? 'Selecione a data' : 'Selecione o horário' }}
                </button>
                <button class="mx-btn mx-btn-text" @click="closeTimePanel">
                    OK
                </button>
            </template>
        </date-picker>
    </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import 'vue2-datepicker/locale/pt-br'

  export default {
    name: 'DateTimeRange',
    components: { DatePicker },
    props: {
      value: [String, Date, Array],
      label: { type: String, default: 'Data:' },
      shortcut: { type: Boolean, default: false },
      hideTime: { type: Boolean, default: false }
    },
    data: () => ({
      showTimePanel: false,
      open: false,
      maxDate: new Date(),
      shortcutsObjects: [
        {
          text: 'Hoje',
          onClick: () => {
            const today = new Date()
            const startOfDay = new Date(today.setHours(0, 0, 0, 0))
            const endOfDay = new Date(today.setHours(23, 59, 59, 999))
            return [startOfDay, endOfDay]
          }
        },
        {
          text: 'Ontem',
          onClick: () => {
            const yesterday = new Date()
            yesterday.setDate(yesterday.getDate() - 1)
            const startOfDay = new Date(yesterday.setHours(0, 0, 0, 0))
            const endOfDay = new Date(yesterday.setHours(23, 59, 59, 999))
            return [startOfDay, endOfDay]
          }
        },
        {
          text: 'Esta semana',
          onClick: () => {
            const today = new Date()
            const dayOfWeek = today.getDay()
            const startOfWeek = new Date(today)
            startOfWeek.setDate(today.getDate() - dayOfWeek)
            startOfWeek.setHours(0, 0, 0, 0)
            const endOfWeek = new Date(today)
            endOfWeek.setDate(today.getDate() + (6 - dayOfWeek))
            endOfWeek.setHours(23, 59, 59, 999)
            return [startOfWeek, endOfWeek]
          }
        },
        {
          text: 'Semana anterior',
          onClick: () => {
            const today = new Date()
            const dayOfWeek = today.getDay()
            const startOfLastWeek = new Date(today)
            startOfLastWeek.setDate(today.getDate() - dayOfWeek - 7)
            startOfLastWeek.setHours(0, 0, 0, 0)
            const endOfLastWeek = new Date(today)
            endOfLastWeek.setDate(today.getDate() - dayOfWeek - 1)
            endOfLastWeek.setHours(23, 59, 59, 999)
            return [startOfLastWeek, endOfLastWeek]
          }
        },
        {
          text: 'Este mês',
          onClick: () => {
            const today = new Date()
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
            firstDayOfMonth.setHours(0, 0, 0, 0)
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
            lastDayOfMonth.setHours(23, 59, 59, 999)
            return [firstDayOfMonth, lastDayOfMonth]
          }
        },
        {
          text: 'Mês passado',
          onClick: () => {
            const today = new Date()
            const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
            firstDayOfLastMonth.setHours(0, 0, 0, 0)
            const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0)
            lastDayOfLastMonth.setHours(23, 59, 59, 999)
            return [firstDayOfLastMonth, lastDayOfLastMonth]
          }
        },
        {
          text: 'Este Ano',
          onClick: () => {
            const today = new Date()
            const firstDayOfYear = new Date(today.getFullYear(), 0, 1)
            firstDayOfYear.setHours(0, 0, 0, 0)
            const lastDayOfYear = new Date(today.getFullYear(), 11, 31)
            lastDayOfYear.setHours(23, 59, 59, 999)
            return [firstDayOfYear, lastDayOfYear]
          }
        },
        {
          text: 'Ano passado',
          onClick: () => {
            const today = new Date()
            const firstDayOfLastYear = new Date(today.getFullYear() - 1, 0, 1)
            firstDayOfLastYear.setHours(0, 0, 0, 0)
            const lastDayOfLastYear = new Date(today.getFullYear() - 1, 11, 31)
            lastDayOfLastYear.setHours(23, 59, 59, 999)
            return [firstDayOfLastYear, lastDayOfLastYear]
          }
        }
      ]
    }),
    computed: {
      date: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      dateFormat () {
        return this.hideTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm'
      }
    },
    methods: {
      closeTimePanel () {
        this.open = false
      },
      toggleTimePanel () {
        this.showTimePanel = !this.showTimePanel
      },
      handleChange (value, type) {
        // Se o tipo for indefinido, se usou um atalho!
        if (type === undefined) {
          this.$emit('filter')
        }
      },
      notAfterToday (date) {
        return date > new Date(new Date().setHours(0, 0, 0, 0))
      }
    }
  }
</script>

<style lang="scss">
.datePicker {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;

    label {
        margin-top: 5px;
        margin-bottom: 8px;
        font-size: 13px;
    }

    .mx-datepicker {
        max-width: 100%;
        width: 100%;
    }

    .mx-datepicker.mx-datepicker-range {
        .mx-input-wrapper {
            input {
                padding: 22px 12px 22px 12px;
                color: var(--dark);
                -webkit-box-flex: 1;
                -ms-flex: 1 1 auto;
                flex: 1 1 auto;
                line-height: 20px;
                max-width: 100%;
                min-width: 0px;
                width: 100%;
                border-radius: 10px;
            }
        }
    }
}
</style>

<style>
.mx-datepicker-sidebar {
    width: 120px;
}

.mx-datepicker-content {
    margin-left: 120px !important;
}

.mx-datepicker-main.mx-datepicker-popup .mx-datepicker-sidebar button {
    overflow-wrap: break-word !important;
    width: 115px !important;
    white-space: pre-line;
    margin-bottom: 10px;
}
</style>
